import React from 'react';
import { Helmet } from 'react-helmet-async';

interface MetaTagsProps {
    title?: string;
    description?: string;
    image?: string;
    name?: string;
    icon?: string;
    url?: string;
    font?: string;
    primaryColor?: string;
    secondaryColor?: string;
}
// You can have more props. In my case, these are enough.
function MetaTags({ title = '', description = '', image = '', name = '', icon = '', url = '', font, primaryColor, secondaryColor }: MetaTagsProps) {
    // Check if required props are ready

    const isDataReady = title && description && url;

    if (!isDataReady) {
        return null;
    }

    return (
        <Helmet defer={false}
            prioritizeSeoTags={true}
            encodeSpecialCharacters={true} >

            {/* Standard metadata tags */}
            <title>{title}</title>
            <link rel='canonical' href={url} />
            {icon && !icon.includes('null') ? <link rel="icon" type="image/png" href={icon} sizes="16x16" /> : ''}
            <meta name='description' content={description} />

            {/* Additional SEO tags */}
            <meta property="article:published_time" content={new Date().toISOString()} />
            <meta property="article:author" content={name} />
            <meta name="robots" content="index, follow" />
            <meta name="googlebot" content="index, follow" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />


            {/* Existing Open Graph and Twitter tags... */}

            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:image:alt" content={title} />
            <meta property="og:site_name" content={name} />

            {/* Twitter Card tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            <style>
                {`
                    :root {
                        ${font ? `--font-family-primary: "${font}, sans-serif";` : ''}
                        ${primaryColor ? `--primaryColor: #${primaryColor};` : ''}
                        ${secondaryColor ? `--secondaryColor: #${secondaryColor};` : ''}
                    }
                `}
            </style>
        </Helmet>
    );
}

export default MetaTags;
